import AppApiAgents from './appApiAgentsResource';
import transformError from '@/api/shared/transformers/errorTransformer';

function getToken({ packageName }) {
  return AppApiAgents.get({ packageName })
    .then(({ body: { apiAgents } }) => ({ apiAgent: apiAgents[0] || null }))
    .catch(transformError);
}

function addToken({ packageName }) {
  return AppApiAgents.save({ packageName }, {})
    .then(({ body }) => body)
    .catch(transformError);
}

function regenerateToken({ packageName, apiAgentId }) {
  return AppApiAgents.regenerateToken({ packageName, apiAgentId }, {})
    .then(({ body }) => body)
    .catch(transformError);
}

function deleteToken({ packageName, apiAgentId }) {
  return AppApiAgents.delete({ packageName, apiAgentId })
    .then(({ body }) => body)
    .catch(transformError);
}

export default {
  getToken,
  addToken,
  deleteToken,
  regenerateToken,
};
